import { Fragment } from 'react'
import { Filter } from '../types'
import { SelectFilterOption } from './select'
import { DateFilterOption } from './date'
import { DateRangeFilterOption } from './date-range'
import { ComboboxFilterOption } from './combobox'

export type OptionsProps = {
  filters: Filter[]
}

export function Options({ filters }: OptionsProps) {
  return (
    <Fragment>
      {filters.map((filter) => getFilterComponent(filter))}
    </Fragment>
  )
}

const getFilterComponent = (filter: Filter) => {
  switch (filter.type) {
    case 'date':
      return (
        <DateFilterOption
          key={filter.id}
          filter={filter}
        />
      )
    case 'date-range':
      return (
        <DateRangeFilterOption
          key={filter.id}
          filter={filter}
        />
      )
    case 'select':
      return (
        <SelectFilterOption
          key={filter.id}
          filter={filter}
        />
      )
    case 'combobox':
      return (
        <ComboboxFilterOption
          key={filter.id}
          filter={filter}
        />
      )
  }
}
